var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoutIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89,
    height: 89,
    viewBox: "0 0 89 89",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 88,
    height: 88,
    rx: 44,
    fill: "#E4F4F9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M65.9 44.5016L53.3 34.0016V40.3016H38.6V48.7016H53.3V55.0016L65.9 44.5016ZM32.3 29.8016H49.1V25.6016H32.3C29.99 25.6016 28.1 27.4916 28.1 29.8016V59.2016C28.1 61.5116 29.99 63.4016 32.3 63.4016H49.1V59.2016H32.3V29.8016Z",
    fill: "#467599"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutIcon);
export default __webpack_public_path__ + "static/media/logout-icon.9ec7c67d2da9f688d7d5ace3fc05187a.svg";
export { ForwardRef as ReactComponent };